import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminWorkspaceChildList from "@/components/admin/admin-workspace-child-list";

const AdminWorkspaceTasksPage = (): JSX.Element => {
	const { workspaceId } = Route.useParams();
	return <AdminWorkspaceChildList entity="tasks" workspaceId={workspaceId} />;
};

export const Route = createFileRoute("/_app/admin/workspaces/$workspaceId/tasks")({
	component: AdminWorkspaceTasksPage,
});
